import React from 'react';
import ProductListContainer from 'src/components/BeaconV2Components/MetricList/ProductListContainer';
import { Field } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { SALES_TABLE_HEADER_DISPLAY_NAMES } from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/Sales/constants';

const fields: Field[] = [
  {
    name: 'retailSales',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.RETAIL_SALES
  },
  {
    name: 'unitsSold',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.UNITS_SOLD
  },
  {
    name: 'retailPrice',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.RETAIL_PRICE
  },
  {
    name: 'wholesalePrice',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.WHOLESALE_PRICE
  },
  {
    name: 'brandCogsPerUnit',
    displayName: SALES_TABLE_HEADER_DISPLAY_NAMES.BRAND_COGS_PER_UNIT
  }
];

/**
 * Shows product grid for prices summary
 */
const PricesSummaryProductGrid = () => {
  const { isProductEntity } = useProductEntity();
  const weekEndingFields = fields.map(removeComparisonFormatter);

  return isProductEntity ? (
    <MetricListContainer
      entityTableHeaderProps={{
        title: 'Retail Price by Week'
      }}
      indexName="sales"
      sortFieldName="retailSales"
      fields={weekEndingFields}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '220px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
    />
  ) : (
    <ProductListContainer
      indexName="sales"
      fields={fields}
      mainFieldName="retailPrice"
      sortFieldName="retailSales"
      entityTableHeaderProps={{
        title: 'Retail Price by Product'
      }}
    />
  );
};

export default PricesSummaryProductGrid;
